<mat-toolbar>
    <div class="logo">
        <img src="assets/img/logo.png" />
    </div>
    <div class="action-list ms-4">
        <button mat-button [matMenuTriggerFor]="ndgMenu">
            <fa-icon [icon]="['fas', 'database']"></fa-icon>
            {{ 'toolbar.ndg.title' | translate }}
        </button>
        <mat-menu #ndgMenu="matMenu">
            <a *ngIf="showInsertNdg()" mat-menu-item [routerLink]="['/ndg/insert']">{{ 'toolbar.ndg.insert' | translate }}</a>
            <a mat-menu-item [routerLink]="['/survey']">{{ 'toolbar.ndg.survey' | translate }}</a>
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="userMenu">
            <fa-icon [icon]="['fas', 'user']"></fa-icon>
            {{ userFullName }}
        </button>
        <mat-menu #userMenu="matMenu">
            <a mat-menu-item (click)="doLogout()">{{ 'toolbar.logout' | translate }}</a>
        </mat-menu>

    </div>
</mat-toolbar>
<router-outlet></router-outlet>
